import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

export const mcpChatTranslationRef = createTranslationRef({
  id: 'mcp-chat',
  messages: {
    leftPane: {
      headerTitle: 'xpert',
      newChat: 'New Chat',
      ariaLabels: {
        openSidebar: 'Open sidebar',
        closeSidebar: 'Close sidebar',
        addNewChat: 'Add new chat',
        search: 'Search',
      },
    },
    activeToolsMenu: {
      title: 'Available Tools',
      loadingText: 'Loading tools...',
      emptyText: 'No tools available',
      ariaLabels: {
        trigger: 'Available tools',
        close: 'Close',
      },
    },
    conversationHistory: {
      starred: 'Starred',
      recent: 'Recents',
      noResults: 'No conversations found',
      noResultsHint: 'Try a different search term',
      emptyState: 'No conversations yet.',
      emptyStateHint: 'Your conversation history will appear here.',
    },
    conversationItem: {
      emptyConversation: 'Empty conversation',
    },
    conversationMenuCard: {
      tooltip: 'More actions',
      ariaLabel: 'more actions',
      rename: 'Rename',
      delete: 'Delete',
    },
    conversationSearchBar: {
      placeholder: 'Search chats',
      ariaLabels: {
        clearSearch: 'Clear search',
      },
    },
    deleteConversationDialog: {
      title: 'Delete this conversation?',
      content: 'Once deleted, this conversation cannot be recovered.',
      cancel: 'Cancel',
      confirm: 'Delete',
    },
    chatContainer: {
      inputPlaceholder: 'Describe what you would like to achieve.',
      errors: {
        defaultError: 'Sorry, I encountered an error processing your request.',
        serviceUnavailable:
          'The MCP Chat service is not available. Please check if the backend is running.',
        networkError:
          'Network error. Please check your connection and try again.',
        loadConversation: 'Failed to load conversation',
      },
    },
    quickStart: {
      heading: 'How can xpert help you today?',
    },
    disclaimer: {
      message:
        'xpert is an AI assistant and can make mistakes. Please verify information before use.',
    },
    headerItem: {
      askXpert: 'Ask xpert',
    },
  },
});
